// extracted by mini-css-extract-plugin
export default {"base":"vp_I_x1n","error":"vp_h2j2S","loader":"vp_ngz7a","heading":"vp_hBMpu","label":"vp_FdqjN","item":"vp_yNkC4","symbol":"vp_TaJtW","wrapper":"vp_iT3r7","append":"vp_z2RNh"};